import eventBus from 'vue-option-events';
import * as HANDLERS from '@/helpers/types/handlers';
import { Encrypt } from '@/helpers/utils';
import { deletePropsFromModelByImagePathInCache } from '@/helpers/page';
import Lookup from '@/helpers/page/library/Lookup';
import utils from './utils';
import { isValidInterpoledValue, extractAndCleanInterpoledValue } from '../../../helpers/utils';
import Vue from 'vue';
import getters from './getters';

const getGroupIndex = (groups, field) => {
  let result;

  groups.filter((item, index) => item.fields.find(x => x.model === field && (result = index)));

  return result;
};

const setReadonly = fields =>
  fields.forEach(field => {
    if (field.type === 'i4proGroupButtons') {
      field.items.forEach(f => {
        if (f.hiddenByPage) f.readonly = true;
      });
    } else field.readonly = true;
  });

const masterReadonly = (state, { page, mode }) => {
  if (state.schemes[page][mode].master && !state.schemes[page][mode].master.readOnlyExtendTabs) return false;

  if (state.models[page].master) {
    if (state.models[page].master.fl_readonly && state.schemes[page][mode].master.readOnlyExtendTabs) return true;
  }

  if (state.parents[page]) {
    if (state.models[state.parents[page]].master && state.models[state.parents[page]].master.fl_readonly) return true;
  }
};

const setReadonlyFields = (state, { page, mode, tab, step, readonlyFields }) => {
  if (mode == 'master') return;
  if (
    (state.models[page][mode] && state.models[page][mode].fl_readonly) ||
    masterReadonly(state, { page, mode, tab })
  ) {
    if (tab) {
      setReadonly(state.schemes[page][mode].tabs.content[tab].fields);
      state.schemes[page][mode].tabs.content[tab].groups.forEach(group => setReadonly(group.fields));
    } else if (step) {
      setReadonly(state.schemes[page][mode].steps.content[step].fields);
      state.schemes[page][mode].steps.content[step].groups.forEach(group => setReadonly(group.fields));
    } else {
      state.schemes[page][mode].groups.forEach(group => setReadonly(group.fields));
      setReadonly(state.schemes[page][mode].fields);
    }
  } else {
    if (tab) {
      state.schemes[page][mode].tabs.content[tab].fields.forEach((field, i) => {
        if (!readonlyFields.includes(field.model)) {
          field.readonly = JSON.parse(
            JSON.stringify(state.initialSchemes[page][mode].tabs.content[tab].fields[i].readonly)
          );
        }
      });
      state.schemes[page][mode].tabs.content[tab].groups.forEach((group, ig) => {
        group.fields.forEach((field, i) => {
          if (!readonlyFields.includes(field.model)) {
            field.readonly = JSON.parse(
              JSON.stringify(state.initialSchemes[page][mode].tabs.content[tab].groups[ig].fields[i].readonly)
            );
          }
        });
      });
    } else if (step) {
      state.schemes[page][mode].steps.content[step].fields.forEach((field, i) => {
        if (!readonlyFields.includes(field.model)) {
          if (
            state.initialSchemes[page][mode].steps &&
            state.initialSchemes[page][mode].steps.content[step].fields[i]
          ) {
            field.readonly = JSON.parse(
              JSON.stringify(state.initialSchemes[page][mode].steps.content[step].fields[i].readonly)
            );
          }
        }
      });
      state.schemes[page][mode].steps.content[step].groups.forEach((group, ig) => {
        group.fields.forEach((field, i) => {
          if (!readonlyFields.includes(field.model)) {
            let stepsContent = state.initialSchemes[page][mode].steps.content[step].groups[ig];
            if (stepsContent && stepsContent.fields[i]) {
              field.readonly = JSON.parse(JSON.stringify(stepsContent.fields[i].readonly));
            }
          }
        });
      });
    } else {
      if ('fields' in state.schemes[page][mode]) {
        state.schemes[page][mode].fields.forEach((field, i) => {
          if (!readonlyFields.includes(field.model)) {
            if ('readonly' in field) {
              field.readonly = JSON.parse(JSON.stringify(state.initialSchemes[page][mode].fields[i].readonly));
            }
          }
        });
      }

      if ('groups' in state.schemes[page][mode]) {
        state.schemes[page][mode].groups.forEach((group, ig) => {
          group.fields.forEach((field, i) => {
            if (!readonlyFields.includes(field.model)) {
              if ('readonly' in field) {
                field.readonly = JSON.parse(
                  JSON.stringify(state.initialSchemes[page][mode].groups[ig].fields[i].readonly)
                );
              }
            }
          });
        });
      }
    }
  }
};

const conditionsList = (state, { page, mode, items }) => {
  let fieldsInConditions = [];
  let executeConditions;
  fieldsInConditions = state.schemes[page][mode].conditions.reduce(
    (result, item) => (result = [...result, ...item.fields.map(field => field.field)]),
    []
  );
  fieldsInConditions.forEach(field => {
    executeConditions = items.reduce((allAffected, item) => {
      if (item[field] !== items[0][field]) allAffected = false;
      return allAffected;
    }, true);
  });

  if (!executeConditions) return;

  if (!!state.schemes[page].list.actions && Object.keys(state.schemes[page].list.actions).length) {
    for (let field of state.schemes[page].list.actions.items) field.visible = true;
  }

  let hideActions = [];

  state.schemes[page][mode].conditions.forEach(condition => {
    condition.fields.forEach(item => {
      if (handleCheckConditions(items[0][item.field], item.operator, item.value)) {
        hideActions = [...hideActions, ...condition.hide.actions];
      }
    });
  });
  hideActions.forEach(action => {
    let btn = state.schemes[page].list.actions.items.find(x => x.name === action);
    btn.visible = false;
  });
};

const changeTabStatus = (tab, condition, tabs) => {
  condition.action.forEach(element => {
    let prop = Object.keys(element)[0] === 'disable' ? 'readonly' : 'show';
    let tabIndex = Object.values(element)[0] - 1;

    if (tabIndex + 1 === tab) return;

    tabs[tabIndex][prop] = prop === 'readonly' ? true : false;
  });
};

const changeStepStatus = (step, condition, steps) => {
  condition.action.forEach(element => {
    let prop = Object.keys(element)[0] === 'disable' ? 'readonly' : 'show';
    let stepIndex = Object.values(element)[0] - 1;

    steps[stepIndex][prop] = prop === 'readonly' ? true : false;
  });
};

const handleCheckConditions = (field, operator, value) => {
  switch (operator) {
    case '===':
      return field === value;
    case '==':
      return field == value;
    case '!=':
      return field != value;
    case '>':
      return field > value;
    case '>=':
      return field >= value;
    case '<':
      return field < value;
    case '<=':
      return field <= value;
    case 'in':
      if (typeof value === 'number' || (Array.isArray(value) && value.every(v => typeof v === 'number'))) {
        field = parseFloat(field);
      }
      return value.includes(field);
    case 'between':
      return field >= parseInt(value[0]) && field <= parseInt(value[1]);
    case 'like':
      if (field === undefined) return false;
      return field === null
        ? false
        : field.toString().toLowerCase().includes(value.toString().toLowerCase())
        ? true
        : false;
    case 'not in':
      if (typeof value === 'number' || (Array.isArray(value) && value.every(v => typeof v === 'number'))) {
        field = parseFloat(field);
      }
      return !value.includes(field);
    case 'not between':
      if (typeof value[0] === 'number' && typeof value[1] === 'number') {
        field = parseFloat(field);
      }
      return field < parseInt(value[0]) || field > parseInt(value[1]);
    case 'not like':
      if (field === undefined) return false;
      return field === null
        ? true
        : !field.toString().toLowerCase().includes(value.toString().toLowerCase())
        ? true
        : false;
    default:
      return false;
  }
};

export const setFieldStatus = (state, { page, mode, tab, step, type, fields }) => {
  let fieldsHideByGroup = [];

  fields.forEach(hide => {
    if (tab) {
      let element = state.schemes[page][mode].tabs.content[tab].fields.find(f => f.model === hide);

      if (element) {
        element[type.prop] = type.value;
      } else {
        let index = getGroupIndex(state.schemes[page][mode].tabs.content[tab].groups, hide);

        if (index !== undefined && index !== null) {
          element = state.schemes[page][mode].tabs.content[tab].groups[index].fields.find(f => f.model === hide);

          element[type.prop] = type.value;
          type.prop === 'visible' && fieldsHideByGroup.push({ index, model: element.model });
        }
      }
    } else if (step) {
      let element = state.schemes[page][mode].steps.content[step].fields.find(f => f.model === hide);

      if (element) {
        element[type.prop] = type.value;
      } else {
        let index = getGroupIndex(state.schemes[page][mode].steps.content[step].groups, hide);

        if (index !== undefined && index !== null) {
          element = state.schemes[page][mode].steps.content[step].groups[index].fields.find(f => f.model === hide);

          element[type.prop] = type.value;
          type.prop === 'visible' && fieldsHideByGroup.push({ index, model: element.model });
        }
      }
    } else {
      let element = state.schemes[page][mode].fields.find(f => f.model === hide);

      if (element) {
        element[type.prop] = type.value;
      } else {
        let index = getGroupIndex(state.schemes[page][mode].groups, hide);

        if (index !== undefined && index !== null) {
          element = state.schemes[page][mode].groups[index].fields.find(f => f.model === hide);

          element[type.prop] = type.value;
          type.prop === 'visible' && fieldsHideByGroup.push({ index, model: element.model });
        }
      }
    }
  });

  return fieldsHideByGroup;
};

const showOrHideGroups = (state, { page, mode, tab, step }) => {
  if (mode === 'master') return;

  // oculta todos os grupos cujo os fields estejam ocultos (exceto para i4proGroupButtons)
  let groupsSchema = [];
  if (tab) {
    groupsSchema = state.schemes[page][mode].tabs.content[tab].groups;
  } else if (step) {
    groupsSchema = state.schemes[page][mode].steps.content[step].groups;
  } else {
    if ('groups' in state.schemes[page][mode]) groupsSchema = state.schemes[page][mode].groups;
  }

  groupsSchema.forEach(groupSchema => {
    const anyButtonVisible = groupSchema.fields.some(
      f => f.type === 'i4proGroupButtons' && f.items.some(a => a.visible)
    );
    const anyFieldVisible = groupSchema.fields.some(f => f.type !== 'i4proGroupButtons' && f.visible);

    if (anyButtonVisible || anyFieldVisible) {
      groupSchema.visible = true;
    } else {
      groupSchema.visible = false;
    }
  });
};

export const toggleProportyOnConditions = (
  state,
  { page, mode, tab, step, readonlyActions, hideActions, conditions, type = 'readonly', dynamic = false }
) => {
  // Pega as actions e groupActions do schema da page
  const actionsScheme = utils.getActionsScheme(state, { page, mode, tab, step });
  const groupButtons = utils.getGroupButtons(state, { page, mode, tab, step });

  // Caso não tenha actions interrompe a execução
  if (!(actionsScheme && actionsScheme.items) && groupButtons.length <= 0 && mode != 'master') return;

  const typeProporty = {
    visible: 'visible',
    readonly: 'readonly'
  };

  const buttonsValueDefault = {
    visible: true,
    readonly: false
  };

  const buttonsValueTruthyConditions = {
    visible: false,
    readonly: true
  };

  // Cria um Array unico com todas as actions da page
  let buttonsOnEach = [];
  if (actionsScheme.items) {
    buttonsOnEach = [...actionsScheme.items];
  }
  if (groupButtons.length > 0) {
    groupButtons.forEach(groupAction => {
      if (groupAction.items) {
        buttonsOnEach = [...buttonsOnEach, ...groupAction.items];
      }
    });
  }

  // Actions a serem modificadas
  const nameButton = readonlyActions ? readonlyActions : hideActions;

  if (dynamic) {
    // Se dynamic for true, altera apenas as ações especificadas em nameButton
    nameButton.forEach(actionNameToToggleProporty => {
      const action = buttonsOnEach.find(el => el.name === actionNameToToggleProporty);
      if (action) {
        action[typeProporty[type]] = buttonsValueTruthyConditions[type];
      }
    });
  } else {
    // Função auxiliar para construir o array com as actions a serem modificadas
    const buildActionsModifyProperty = conditions => {
      let actionsModifyProperty = [];
      if (conditions && Array.isArray(conditions)) {
        conditions.forEach(condition => {
          if (condition.hide && condition.hide.actions) {
            actionsModifyProperty.push(...condition.hide.actions);
          }
          if (condition.readonly && condition.readonly.actions) {
            actionsModifyProperty.push(...condition.readonly.actions);
          }
        });
      }
      return actionsModifyProperty;
    };

    // Iteração padrão sobre buttonsOnEach
    buttonsOnEach.forEach(el => {
      const idNotExistis = !nameButton.find(actionNameToToggleProporty => el.name === actionNameToToggleProporty);
      const allowsNotEditing = el.hidden === true;
      const actionsModifyProperty = buildActionsModifyProperty(conditions);

      // A propriedade hidden força o visible como false para sempre ficar oculto em tela
      if (allowsNotEditing && type === 'visible') {
        el[typeProporty[type]] = false;
        return;
      }

      // Verificação se el.name está em actionsModifyProperty
      if (!actionsModifyProperty.includes(el.name)) {
        return; // Interrompe a execução do restante do código para este elemento
      }

      // Atribuição de propriedades com base nas condições
      el[typeProporty[type]] = idNotExistis ? buttonsValueDefault[type] : buttonsValueTruthyConditions[type];
    });
  }
};

export default {
  setPage: (state, { model, scheme }) => {
    state.models = { ...state.models, ...model };
    state.schemes = { ...state.schemes, ...scheme };

    const cloneStatePersist = structuredClone(state.models);
    deletePropsFromModelByImagePathInCache(cloneStatePersist);

    sessionStorage.setItem('data', Encrypt(cloneStatePersist, 'i4pro'));
  },

  updateSelectedItems: (state, payload) => {
    const { selectedItems, keyValue, conditions } = payload;

    if (conditions && conditions.actionConditionsOnSelectedItems.length > 0) {
      let { page, mode, actionConditionsOnSelectedItems } = conditions;
      toggleProportyOnConditions(state, {
        page,
        mode,
        readonlyActions: selectedItems.length > 0 ? [] : actionConditionsOnSelectedItems,
        type: 'readonly'
      });
    }

    state.selectedItems.keyValue = keyValue;
    state.selectedItems.items = selectedItems;
  },

  setMode: (state, { page, mode }) => {
    eventBus.$emit(HANDLERS.CHANGE_COMPONENT_IN_TAB, {
      page,
      context: mode
    });
    eventBus.$emit(HANDLERS.UPDATE_COMPONENT, {
      mode,
      page
    });

    state.schemes[page].default = mode;
  },

  setModel: (state, { page, data, masterContent, mode }) => {
    const type = masterContent ? 'master' : mode;

    let updatedModel = data;
    if (mode !== 'list') {
      if (state.models[page] && 'master' in state.models[page]) {
        updatedModel = {
          ...state.models[page].master,
          ...updatedModel,
        };
      }
    }

    if (!!state.models[page]) {
      state.models[page] = {
        ...state.models[page],
        ...{
          [type]: updatedModel
        }
      };
    } else {
      state.models = {
        ...state.models,
        ...{
          [page]: {
            [type]: updatedModel
          }
        }
      };
    }

    const cloneStatePersist = structuredClone(state.models);
    deletePropsFromModelByImagePathInCache(cloneStatePersist);

    sessionStorage.setItem('data', Encrypt(cloneStatePersist, 'i4pro'));
  },

  changePageMode: (state, { page, mode }) => {
    state.schemes[page].default = mode;
    if (page !== state.main) {
      eventBus.$emit(HANDLERS.CHANGE_COMPONENT_IN_TAB, { page, context: mode });
    }
  },

  setTabScheme: (state, payload) => {
    if (payload.page === 'dev') return;

    const conditions = state.schemes[payload.page][payload.mode].master.tabConditions;
    const tabs = state.schemes[payload.page][payload.mode].tabs.headers;
    const model = state.models[payload.page]['master']
      ? state.models[payload.page]['master']
      : state.models[payload.page][payload.mode];

    tabs.forEach(element => {
      element.show = true;
      element.readonly = false;
    });

    conditions &&
      conditions.forEach(condition => {
        if (handleCheckConditions(payload.tab, condition.operator, condition.tab)) {
          if (condition.condition.length && !!model) {
            let execute = false;
            condition.condition.forEach(item => {
              if (handleCheckConditions(model[item.field], item.operator, item.value)) execute = true;
              if (execute) changeTabStatus(payload.tab, condition, tabs);
            });
          } else {
            changeTabStatus(payload.tab, condition, tabs);
          }
        }
      });
  },

  setStepScheme: (state, payload) => {
    if (payload.page === 'dev') return;

    const conditions = state.schemes[payload.page][payload.mode].steps.stepConditions;
    const steps = state.schemes[payload.page][payload.mode].steps.headers;
    const model = state.models[payload.page][payload.mode];

    steps.forEach(element => {
      element.show = true;
      element.readonly = false;
    });

    if (conditions) {
      conditions.forEach(condition => {
        if (handleCheckConditions(payload.step, condition.operator, condition.step)) {
          if (condition.condition.length) {
            let execute = false;
            condition.condition.forEach(item => {
              if (handleCheckConditions(model[item.field], item.operator, item.value)) execute = true;

              if (execute) changeStepStatus(payload.step, condition, steps);
            });
          } else {
            changeStepStatus(payload.step, condition, steps);
          }
        }
      });
    }
  },

  setLookupList: (state, payload) => {
    const { page, mode } = payload.info;
    const { name, items, model } = payload.data;

    if (!items.length) return;

    let key = state.schemes[page][mode].attributes.attributesTable.keyValue;

    state.schemes[page][mode].lookups[model[key]].find(x => x.model === name).attributesSelect.items = items;
  },

  setLookupListInit: (state, payload) => {
    const { page, items, key } = payload;

    for (let item of items) {
      if (item.typeLookup === 'normal' && state.schemes[page]['list'].lookups[key]) {
        let field = state.schemes[page]['list'].lookups[key].find(x => x.model === item.name);
        field.attributesSelect.items = item.items;
      }
    }
  },

  setLookupListScheme: (state, payload) => {
    const { page, mode } = payload.info;

    let key = state.schemes[page][mode].attributes.attributesTable.keyValue;

    for (let item of state.models[page][mode]) {
      state.schemes[page][mode].lookups = {
        ...state.schemes[page][mode].lookups,
        [item[key]]: JSON.parse(JSON.stringify(state.schemes[page][mode].fields))
      };
    }
  },

  setActionsCondition: (state, payload) => {
    let key = state.schemes[payload].list.attributes.attributesTable.keyValue;

    for (let item of state.models[payload].list) {
      state.schemes[payload].list.recordActions = {
        ...state.schemes[payload].list.recordActions,
        [item[key]]: JSON.parse(JSON.stringify(state.schemes[payload].list.recordActionsModel))
      };
    }
  },

  initConditionsList: (state, { page, mode, items, key }) => {
    if (!state.schemes[page][mode].conditions) return;

    const newItems = items.map(item => state.models[page][mode].find(x => x[key] === item[key]));
    conditionsList(state, { page, mode, items: newItems });
  },

  initInlineConditionsList: (state, { page, mode, items }) => {
    if (!state.schemes[page][mode].inlineConditions.length) return;

    const key = state.schemes[page][mode].attributes.attributesTable.keyValue;
    const models = state.models[page][mode];
    const records = items.map(item => item[key]);

    records.forEach(value => {
      let hide;
      let hideFields = [];
      let readonlyFields = [];
      let hideActions = [];

      state.schemes[page][mode].inlineConditions.forEach(condition => {
        var fieldsCheckConditions = true;

        condition.fields.forEach(item => {
          const found = models.find(x => x[key] === value);
          if (found) {
            hide = handleCheckConditions(found[item.field], item.operator, item.value);
            if (!hide) fieldsCheckConditions = false;
          }
        });

        if (hide && fieldsCheckConditions) {
          hideFields = [...hideFields, ...condition.hide.fields];
          hideActions = [...hideActions, ...condition.hide.actions];
          readonlyFields = [...readonlyFields, ...condition.readonly.fields];
        }
      });

      for (let field of state.schemes[page].list.recordActions[value]) field.visible = true;
      hideActions.forEach(action => {
        let btn = state.schemes[page].list.recordActions[value].find(x => x.name === action);
        btn.visible = false;
      });

      if (!state.schemes[page][mode].lookups) return;

      for (const field of state.schemes[page][mode].lookups[value]) {
        if ('hidden' in field) {
          field.visible = false;
        } else {
          field.visible = true;
        }
      }

      hideFields.forEach(hide => {
        let field = state.schemes[page][mode].lookups[value].find(f => f.model === hide);
        field.visible = false;
        let model = models.find(x => x[key] === value);
        model[hide] = null;

        const hideColumn = items.reduce((all, item) => {
          if (state.schemes[page][mode].lookups[item[key]].find(f => f.model === hide).visible) all = false;
          return all;
        }, true);

        if (hideColumn) {
          let colunm = state.schemes[page][mode].headers.find(x => x.value === hide);
          if (!!colunm) {
            colunm.visible = false;
          }
        }
      });

      readonlyFields.forEach(hide => {
        let field = state.schemes[page][mode].lookups[value].find(f => f.model === hide);
        field.readonly = true;
      });
    });
  },

  initConditionsOnSelectedItems: (state, { page, mode, key, tab, step }) => {
    if (!state.schemes[page][mode]?.conditionsOnSelectedItems?.actionsToReadOnly.length) return;

    if (!state.schemes[page][mode].attributes.attributesTable.dataTable.showSelect) {
      console.error('A condição baseadas em seleções de items precisam conter o atributo showSelect');
      return;
    }

    let readonlyActions = state.schemes[page][mode].conditionsOnSelectedItems.actionsToReadOnly;
    toggleProportyOnConditions(state, {
      page,
      mode,
      tab,
      step,
      readonlyActions,
      type: 'readonly'
    });
  },

  setInlineConditionsList: (state, { page, mode, item, items }) => {
    const key = state.schemes[page][mode].attributes.attributesTable.keyValue;
    const value = item[key];

    let conditions = state.schemes[page][mode].inlineConditions;
    let model = state.models[page][mode];

    if (!conditions) return;

    let hide;
    let hideFields = [];
    let readonlyFields = [];
    let hideActions = [];

    conditions.forEach(condition => {
      var fieldsCheckConditions = true;

      condition.fields.forEach(item => {
        hide = handleCheckConditions(model.find(x => x[key] === value)[item.field], item.operator, item.value);
        if (!hide) fieldsCheckConditions = false;
      });

      if (hide && fieldsCheckConditions) {
        hideFields = [...hideFields, ...condition.hide.fields];
        hideActions = [...hideActions, ...condition.hide.actions];
        readonlyFields = [...readonlyFields, ...condition.readonly.fields];
      }
    });

    for (const field of state.schemes[page][mode].lookups[value]) {
      if ('hidden' in field) {
        field.visible = false;
      } else {
        field.visible = true;
      }
    }
    for (let header of state.schemes[page][mode].headers) header.visible = true;

    hideFields.forEach(hide => {
      let field = state.schemes[page][mode].lookups[value].find(f => f.model === hide);

      field.visible = false;

      const hideColumn = items.reduce((all, item) => {
        if (state.schemes[page][mode].lookups[item[key]].find(f => f.model === hide).visible) all = false;
        return all;
      }, true);

      if (hideColumn) {
        let colunm = state.schemes[page][mode].headers.find(x => x.value === hide);
        if (!!colunm) {
          colunm.visible = false;
        }
      }
    });

  readonlyFields.forEach(hide => {
    let field = state.schemes[page][mode].lookups[value].find(f => f.model === hide);
    if (field) {
      field.readonly = true;
    }
  });

  state.schemes[page][mode].lookups[value].forEach(field => {
    if (!readonlyFields.includes(field.model)) {
      field.readonly = false;
    }
  });

    for (let field of state.schemes[page].list.recordActions[value]) field.visible = true;
    hideActions.forEach(action => {
      let btn = state.schemes[page].list.recordActions[value].find(x => x.name === action);
      btn.visible = false;
    });
  },

  maskCondition: (state, { page, mode, tab, step, hasMaskedField }) => {
    if (hasMaskedField) {
      eventBus.$emit(HANDLERS.DISABLE_ACTIONS, { page, mode, tab, step });

      if (mode === 'list') {
        for (let lookup in state.schemes[page][mode].lookups) {
          state.schemes[page][mode].lookups[lookup].forEach(field => {
            field.readonly = true;
          });
        }

        return;
      }

      if (tab) {
        const fields = state.schemes[page][mode].tabs.content[tab].fields;
        const groups = state.schemes[page][mode].tabs.content[tab].groups;

        fields.forEach(field => {
          field.readonly = true;
        });

        groups.forEach(group =>
          group.fields.forEach(field => {
            field.readonly = true;
          })
        );
      } else if (step) {
        const fields = state.schemes[page][mode].steps.content[step].fields;
        const groups = state.schemes[page][mode].steps.content[step].groups;

        fields.forEach(field => {
          field.readonly = true;
        });

        groups.forEach(group =>
          group.fields.forEach(field => {
            field.readonly = true;
          })
        );
      } else {
        const fields = state.schemes[page][mode].fields;
        const groups = state.schemes[page][mode].groups;

        fields.forEach(field => {
          field.readonly = true;
        });

        groups.forEach(group =>
          group.fields.forEach(field => {
            field.readonly = true;
          })
        );
      }
    }
  },

  setConditions: (state, { page, mode, tab, step }) => {
    let conditions;
    const model = state.models[page][mode];
    let fieldsHideByGroup = [];

    if (tab && state.schemes[page][mode].tabs) {
      conditions = state.schemes[page][mode].tabs.content[tab].conditions;
    } else if (step && state.schemes[page][mode].steps.content[step]) {
      conditions = state.schemes[page][mode].steps.content[step].conditions;
    } else {
      conditions = state.schemes[page][mode]?.conditions || false;
    }

    if (!conditions || (!!conditions && !conditions.length)) return;

    let hide;
    let hideFields = [];
    let readonlyFields = [];
    let hideActions = [];
    let readonlyActions = [];

    // Este bloco de código verifica cada condição em conditions, validando se o VALUE está interpolado, se esiver, ele executa a condition de maneira dinâmica.
    const subPageOf = getters.subPageOf(state)(page);
    let subPages = getters.subPages(state)(subPageOf); // Obtendo inicialmente subPages
    if (subPageOf == undefined) subPages = [{ name: page, mode: mode }];

    const processFieldVisibilityAndActions = (condition, subPages) => {
      processFields(condition.hide.fields, subPages, 'hide', 'visible');
      processFields(condition.readonly.fields, subPages, 'readonly', 'readonly');
      processActions(condition.hide.actions || [], subPages, 'hide', 'visible');
      processActions(condition.readonly.actions || [], subPages, 'readonly', 'readonly');
    };

    const processFields = (items, subPages, type, prop) => {
      for (let item of items) {
        subPages.forEach(sub => {
          const scheme = state.models[sub.name][sub.mode];
          if (scheme.hasOwnProperty(item)) {
            setFieldStatus(state, {
              page: sub.name,
              mode: sub.mode,
              tab,
              step,
              type: { prop, value: type === 'hide' ? false : true },
              fields: [item]
            });
          }
        });
      }
    };

    const processActions = (actions, subPages, type, prop) => {
      for (let action of actions) {
        subPages.forEach(sub => {
          const actions = state.schemes[sub.name][sub.mode].actions;
          const actionsInFields = state.schemes[sub.name][sub.mode].fields;

          const processAction = item => {
            if (item.name === action) {
              toggleProportyOnConditions(state, {
                page: sub.name,
                mode: sub.mode,
                tab,
                step,
                [`${type}Actions`]: [action],
                type: prop,
                dynamic: true
              });
            }
          };

          if (actions && actions.items) {
            actions.items.forEach(processAction);
          } else if (actionsInFields) {
            actionsInFields.forEach(field => {
              if (field.items) {
                field.items.forEach(processAction);
              }
            });
          }
        });
      }
    };

    const resetPattern = subPages => {
      subPages.forEach(sub => {
        toggleProportyOnConditions(state, {
          page: sub.name,
          mode: sub.mode,
          tab,
          step,
          readonlyActions,
          type: 'readonly'
        });
        toggleProportyOnConditions(state, {
          page: sub.name,
          mode: sub.mode,
          tab,
          step,
          hideActions,
          type: 'visible'
        });
        if (sub.name !== page || sub.mode !== mode) {
          utils.setFieldVisibility(state, {
            page: sub.name,
            mode: sub.mode,
            tab,
            step,
            hideFields,
            readonlyFields,
            dynamic: true
          });
        }
      });
    };

    const processCondition = condition => {
      let fieldsCheckConditions = true;

      for (const item of condition.fields) {
        if (isValidInterpoledValue(item.value)) {
          const updatedValue = Array.isArray(item.value)
            ? item.value.map(extractAndCleanInterpoledValue)
            : extractAndCleanInterpoledValue(item.value);

          const modelValues = Array.isArray(updatedValue) ? updatedValue.map(val => model[val]) : model[updatedValue];

          hide = !!model && handleCheckConditions(model[item.field], item.operator, modelValues);

          // Se a condição for atendida, processa a visibilidade e ações dos campos
          if (hide) {
            processFieldVisibilityAndActions(condition, subPages);
          } else if (!hide) {
            // Se a condição não for atendida, redefine os campos e ações para o padrão
            fieldsCheckConditions = false;
            resetPattern(subPages);
          }
        } else {
          // Verifica a condição diretamente se o valor não for interpolado
          hide = !!model && handleCheckConditions(model[item.field], item.operator, item.value);
        }
        if (!hide) {
          fieldsCheckConditions = false;
          break;
        }
      }
      if (hide && fieldsCheckConditions) {
        hideFields.push(...condition.hide.fields);
        if (condition.hide.actions) {
          hideActions.push(...condition.hide.actions);
        }
        readonlyFields.push(...condition.readonly.fields);
        if (condition.readonly.actions) {
          readonlyActions.push(...condition.readonly.actions);
        }
      }
    };

    const processAllConditions = () => {
      for (const condition of conditions) {
        processCondition(condition);
      }
    };

    // Verifica se há algum valor interpolado nas condições
    const hasInterpoledValue = conditions.some(condition =>
      condition.fields.some(item => isValidInterpoledValue(item.value))
    );

    if (hasInterpoledValue) {
      // Obtém as subpáginas do estado
      subPages = getters.subPages(state)(subPageOf) ?? subPages ?? [];
      if (subPages && subPages.length > 0) {
        processAllConditions();
      } else {
        // Monitora mudanças nas subpáginas e processa as condições quando houver novas subpáginas
        utils.monitorSubPagesChange(getters, state, subPageOf, newSubPages => {
          subPages = newSubPages;
          processAllConditions();
        });
      }
    } else {
      processAllConditions();
    }
    setReadonlyFields(state, { page, mode, tab, step, readonlyFields });

    // O trecho de código que manipulava visibilidade dos campos(fields), foi migrada para uma função em utils,
    //para melhorar legibilidade desse arquivo.
    utils.setFieldVisibility(state, { page, mode, tab, step, hideFields, readonlyFields, dynamic: false });

    fieldsHideByGroup = setFieldStatus(state, {
      page,
      mode,
      tab,
      step,
      type: { prop: 'visible', value: false },
      fields: hideFields
    });

    setFieldStatus(state, { page, mode, tab, step, type: { prop: 'readonly', value: true }, fields: readonlyFields });

    // removido o uso de eventos no setConditons pois apresentava problemas quando as conditions eram executadas antes da
    // pagina ser totalmente montada. O Sleep foi incluindo como um paliativo mas ainda causava erros de vez em quando
    // agora a propriedade visible ser alterada direto no schema
    //await sleep(100);
    //eventBus.$emit(HANDLERS.SHOW_GROUPS, { page, mode, tab, step });
    // await sleep(100);
    // eventBus.$emit(HANDLERS.SHOW_ACTIONS, { mode, page });

    toggleProportyOnConditions(state, { page, mode, tab, step, hideActions, conditions, type: 'visible'});
    toggleProportyOnConditions(state, { page, mode, tab, step, readonlyActions, conditions,type: 'readonly' });

    // botões (actions) e campos (fields) deve ser ocultados primeiro depois grupos que ficaram com todos os itens invisíveis se tornarão invisíveis também.
    showOrHideGroups(state, { page, mode, tab, step });
  },

  setSubPagesConditions(state, { page, mode }) {
    const conditions = state.schemes[page][mode]?.conditions || false;

    if (!conditions) {
      return;
    }

    let pagesToHide = [];

    for (const condition of conditions) {
      let fieldsCheckConditions = true;

      for (const field of condition.fields) {
        let model = null;

        if (field.mode === 'list' && field.index !== undefined) {
          model = state.models[field.page][field.mode][field.index];
        } else {
          model = state.models[field.page][field.mode];
        }

        if (!model) {
          fieldsCheckConditions = false;
          break;
        }

        let hide = false;
        if (field.mode === 'list' && !field.value && field.index === undefined) {
          if (field.operator === '==' || field.operator === '==') {
            hide = Array.isArray(model) && !model.length;
          } else if (field.operator === '!=') {
            hide = Array.isArray(model) && model.length;
          }
        } else if (field.field) {
          hide = handleCheckConditions(model[field.field], field.operator, field.value);
        }

        if (!hide) {
          fieldsCheckConditions = false;
          break;
        }
      }

      if (fieldsCheckConditions) {
        pagesToHide = [...pagesToHide, ...condition.hide.pages];
      }
    }

    eventBus.$emit(HANDLERS.HIDE_SUBPAGES, pagesToHide);
  },

  /*clear: (state, payload) => {
    if (payload) {
      state.schemes = { [payload]: JSON.parse(JSON.stringify(state.schemes[payload])) };
      state.models = { [payload]: JSON.parse(JSON.stringify(state.models[payload])) };
    } else {
      state.schemes = {};
      state.models = {};
    }
    state.parents = {};
  },*/

  updateModel: (state, { page, mode, model, setSessionStorage=true }) => {
    if (model) {
      let updatedModel;
      if (Array.isArray(model)) {
        updatedModel = model
      } else {
        updatedModel = {
          ...state.models[page][mode],
          ...model
        }
      }

      state.models[page][mode] = updatedModel;
    }

    const cloneStatePersist = structuredClone(state.models);
    deletePropsFromModelByImagePathInCache(cloneStatePersist);

    if (setSessionStorage) sessionStorage.setItem('data', Encrypt(cloneStatePersist, 'i4pro'));
  },

  updateModelList: (state, { page, mode, model }) => {
    let param = state.schemes[page][mode].attributes.attributesTable.keyValue;

    const index = state.models[page][mode].findIndex(x => x[param] === model[param]);

    // Caso a model já exista, atualiza apenas os valores que vem da model como parâmetro
    // desta forma a referência das [keys] do objeto nunca é perdida
    if (state.models[page][mode][index]) {
      Object.assign(state.models[page][mode][index], model);
    } else {
      state.models[page][mode][index] = model;
    }

    const cloneStatePersist = structuredClone(state.models);
    deletePropsFromModelByImagePathInCache(cloneStatePersist);

    sessionStorage.setItem('data', Encrypt(cloneStatePersist, 'i4pro'));
  },

  hideGroup: (state, { page, mode, tab, step, group }) => {
    let groups;

    if (tab) {
      groups = state.schemes[page][mode].tabs.content[tab].groups;
    } else if (step) {
      groups = state.schemes[page][mode].steps.content[step].groups;
    } else {
      groups = state.schemes[page][mode].groups;
    }

    groups[group].visible = false;
  },

  showGroups: (state, { page, mode, tab, step }) => {
    let groups;

    if (tab) {
      groups = state.schemes[page][mode].tabs.content[tab].groups;
    } else if (step) {
      groups = state.schemes[page][mode].steps.content[step].groups;
    } else {
      groups = state.schemes[page][mode].groups;
    }

    for (let group of groups) {
      group.visible = true;
    }
  },

  setLookup: (state, payload) => new Lookup(payload, state, getGroupIndex),

  setMain: (state, payload) => (state.main = payload),

  setScheme: (state, scheme) => (state.schemes = { ...state.schemes, ...scheme }),

  setParent: (state, { page, parent }) => (state.parents = { ...state.parents, [page]: parent }),

  setInitialScheme: (state, scheme) => (state.initialSchemes = { ...state.initialSchemes, ...scheme }),

  setInputValue: (state, { page, mode, field, value }) => (state.models[page][mode][field] = value),

  setCurrentTab: (state, { page, tab }) => {
    state.currentTabs = {
      ...state.currentTabs,
      ...{ [page]: tab }
    };
  },

  setPageFilter: (state, { page, redirectParams }) => (state.pageFilter[page] = redirectParams),

  setPageFilterOffset: (state, { page, offsetParams }) => {
    if (state.pageFilter[page]?.offset) {
      state.pageFilter[page].offset = offsetParams;
    }
  },

  setDefaultFilter: (state, { page, model }) => (state.defaultFilter[page] = model),

  clearPageModel: (state, { page, mode }) =>
    state.models[page] && state.models[page][mode] && delete state.models[page][mode],

  clearPageFilter: (state, page) => delete state.pageFilter[page],

  clearDefaultFilter: (state, page) => delete state.defaultFilter[page],

  resetDefaultFilter: state => (state.defaultFilter = {}),

  resetPageFilter: state => (state.pageFilter = {}),

  cleanFiltersAfterReturn: (state, page) => {
    const keepFilters = ['limit', 'offset', 'sortBy', 'sortDesc'];

    const defaultFilters = keepFilters.reduce((acc, props) => {
      if (state.pageFilter[page].hasOwnProperty(props)) {
        acc[props] = state.pageFilter[page][props];
      }

      return acc;
    }, {});

    state.pageFilter[page] = defaultFilters;
  },

  clear: state => {
    state.currentTabs = {};
    state.defaultFilter = {};
    state.models = {};
    state.pageFilter = {};
    state.schemes = {};
    state.parents = {};
    state.initialSchemes = {};
  }
};
